<template>
  <q-page class="flex flex-center">
    <!--Submind is a website for coders, hackers, engineers who want to record their thoughts fluidly.-->
    <div class="row absolute-top q-pt-md">
      <div class="col-3"></div>
      <div class="col-6">
        <h3 style="text-align: center" class="q-mt-sm q-mb-md">Submind</h3>
        <div class="q-headline q-pb-sm" style="text-align: center">Get started</div>
        <div class="row" style="text-align: center">
          <div class="col-3"></div>
          <div class="col-6">
            <q-btn color="primary" class="q-mb-md" style="width: 20vh;" @click="showLoginDialog">Register/Login</q-btn>
            <q-btn color="secondary" class="q-mb-md" style="width: 20vh;" @click="goToDocs">View the Docs</q-btn>
          </div>
          <div class="col-3"></div>
        </div>
        <div class="q-pb-md" style="text-align: center;">
          Submind is a note taking app designed for coders. It allows users to experiment with
          tools that help organise their work.  Submind was built to solve some of the frustrations of other note taking apps
          that aim to please everyone. Instead of being generalised, Submind focuses on the technical user.  It allows
          unparalleled customisation for those who understand some basic HTML, CSS and JavaScript.
        </div>
        <img width="100%" class="shadow-1" src="https://firebasestorage.googleapis.com/v0/b/submindfire.appspot.com/o/public%2Fsubmind%2Findex%2FInterface.png?alt=media&token=c2273428-b6d5-49f3-88ea-bd0e75ef93c3">
      </div>
      <div class="col-3"></div>
    </div>
  </q-page>
</template>

<style>
</style>

<script>
export default {
  name: 'PageIndex',
  data () {
    return {
      treeViewOpen: true
    }
  },
  methods: {
    showLoginDialog () {
      this.$parent.$parent.$parent.showLoginDialog()
    },
    goToDocs () {
      this.$router.push('/docs/home')
    }
  }
}
</script>
